export default {
  duration: '250ms',
};
